module.exports = __webpack_public_path__ + "media/images/athletes/2468-3ec2a4a1138af68b0031f6716aee5f2d.png";